<!-- Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <div class="header-actions">
    <i class="fa" 
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}" 
       style="margin-right: 10px; cursor: pointer;" 
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- Modal Body -->
<div class="modal-body no-modal-body-scroll" [hidden]="minimise">
  <div class="tab-content" style="padding-top: 0 !important;">
      
      <!-- Loading Spinner -->
      @if (showFormLoader) {
<div class="formLoader">
        <i class="fa fa-spinner fa-spin gt-refresh"></i>
      </div>
}
      
      @if (!showFormLoader) {
<form name="screenFrom" id="screenFrom" class="form-horizontal" novalidate>
        
        <!-- Custom Entity Information Table (Original Structure) -->
        <div style="padding-bottom: 0 !important;">
          <table style="width: 100%; border: 0px; border-spacing: 0;" class="custom-table">
            <tbody>
              <tr>
                <td class="LayerLine1" nowrap>Entity:</td>
                <td class="LayerData1" nowrap>
                  {{entityInfo?.leid}} : {{entityInfo?.leName}} : {{entityInfo?.taxYearBegin}} - {{entityInfo?.taxYearEnd}}
                </td>
                <td class="LayerLine1" nowrap>Business:</td>
                <td class="LayerData1" nowrap>
                  {{entityInfo?.meCode}} - {{entityInfo?.meName}}
                </td>
                <td class="LayerLine1" nowrap>Tax Code:</td>
                <td class="LayerData1" nowrap>{{entityInfo?.cdrNo}}</td>
              </tr>
            </tbody>
          </table>
          
          <table class="InnerTblBG custom-table" style="width: 100%; border: 0px; border-spacing: 0; font-weight: bold;">
            <tbody>
              <tr>
                <td class="BlackSmHdrBC">
                  <h4>{{f6252Header?.ATTRIB_DESCRIPTION || 'Form 6252'}}</h4>
                </td>
              </tr>
            </tbody>
          </table>

          <!-- Property Table Container -->
          @if (!showFormLoader) {
<div id="table_container" class="table-scroll">
            <table class="table table-bordered form-inline InnerTblBG custom-table">
              
              <!-- Process each IS_MULTI group -->
              @for (row of f6252FormData; track $index; let mainIndex = $index) {

                @if (row.IS_MULTI==='Y') {
<tr>
                  <td colspan="12">
                    <table class="table table-bordered form-inline InnerTblBG custom-table">
                      
                      <!-- Iterate through Row_data -->
                      @for (item of row.Row_data; track $index; let parentIndex = $index) {
<tr>
                        
                        <!-- HEADER_ROW cells -->
                        @if (item.Line_Type==='HEADER_ROW') {

                          @for (column of item.Line_data; track $index; let colIdx = $index) {
<th>
                            <p>{{column.ATTRIB_VALUE}}@if (!column.ATTRIB_VALUE && colIdx === 0) {
&nbsp;
}</p>
                          </th>
}
                        
}
                      
                        <!-- SUB_ROW cells -->
                        @if (item.Line_Type==='SUB_ROW') {
<td>
                          {{item.Line_no}}
                          <i class="fa fa-plus-circle color-green fa-lg pull-right"
                             style="cursor: pointer; margin-top: 4px;"
                             title="Add Details"
                             (click)="AddNewRow(item.TRANS_OCCURRENCE, item.Line_no, parentIndex)">
                          </i>
                        </td>
}
                        @if (item.Line_Type==='SUB_ROW') {
<td colspan="8">
                          Add Details
                        </td>
}
                      
                        <!-- DATA_ROW cells (Existing Property) -->
                        @if (item.Line_Type==='DATA_ROW' && item.Is_Multi==='Y') {
<td 
                            style="width: 4%">
                          @if (item.IS_EDITABLE==='Y') {
<i class="fa fa-pencil bluepencil pull-left"
                            
                             style="cursor: pointer; margin-top: 4px;"
                             title="Edit Details"
                             (click)="editExistingRecord(item.Line_no, item.TRANS_OCCURRENCE, parentIndex, 'edit')">
                          </i>
}
                          @if (item.IS_EDITABLE==='Y') {
<i class="fa fa-lg pull-right"
                            
                             [ngClass]="crudLoading && deletingOccurrence === item.TRANS_OCCURRENCE ? 'fa-spinner fa-pulse' : 'fa-minus-circle color-red'"
                             [style.cursor]="crudLoading && deletingOccurrence === item.TRANS_OCCURRENCE ? 'not-allowed' : 'pointer'"
                             [style.marginTop.px]="4"
                             [title]="crudLoading && deletingOccurrence === item.TRANS_OCCURRENCE ? 'Deleting...' : 'Remove Details'"
                             (click)="!crudLoading && removeExistingRecord(item.Line_no, item.TRANS_OCCURRENCE, parentIndex)">
                          </i>
}
                        </td>
}
                        
                        @if (item.Line_Type==='DATA_ROW' && item.Is_Multi==='Y') {

                          @for (column of item.Line_data.slice(1, item.Line_data.length); track $index) {
<td 
                              [ngStyle]="{'width': column.COLSPAN + '%'}">
                            <!-- Number -->
                            @if (column.DATA_TYPE == 'number') {
<p 
                               [class.color-red]="column.ATTRIB_VALUE < 0">
                              {{column.ATTRIB_VALUE | numberWithCommas}}
                              @if (column.HAS_ERROR==='Y') {
<span class="form-error-container">
                                {{column.ATTRIB_VALUE_ERROR}}
                              </span>
}
                            </p>
}
                            <!-- String (non-dropdown) -->
                            @if (column.DATA_TYPE != 'number' && column.EDIT_TYPE != 'dropdown') {
<p>
                              {{column.ATTRIB_VALUE}}
                              @if (column.HAS_ERROR==='Y') {
<span class="form-error-container">
                                {{column.ATTRIB_VALUE_ERROR}}
                              </span>
}
                            </p>
}
                            <!-- Dropdown (display) -->
                            @if (column.EDIT_TYPE === 'dropdown' && column.DATA_TYPE === 'string') {
<p>
                              {{column.ATTRIB_VALUE}}
                              @if (column.HAS_ERROR==='Y') {
<span class="form-error-container">
                                {{column.ATTRIB_VALUE_ERROR}}
                              </span>
}
                            </p>
}
                          </td>
}
                        
}
                      
                        <!-- NEW_EDIT_ROW cells (Editing Property) -->
                        @if (item.Line_Type==='NEW_EDIT_ROW' && item.Is_Multi==='Y') {
<td>
                          <i class="fa fa-lg pull-right"
                             [ngClass]="crudLoading && deletingOccurrence === item.TRANS_OCCURRENCE ? 'fa-spinner fa-pulse' : 'fa-minus-circle color-red'"
                             [style.cursor]="crudLoading && deletingOccurrence === item.TRANS_OCCURRENCE ? 'not-allowed' : 'pointer'"
                             [style.marginTop.px]="4"
                             [title]="crudLoading && deletingOccurrence === item.TRANS_OCCURRENCE ? 'Deleting...' : 'Remove Details'"
                             (click)="!crudLoading && removeExistingRecord(item.Line_no, item.TRANS_OCCURRENCE, parentIndex)">
                          </i>
                        </td>
}
                        
                        @if (item.Line_Type==='NEW_EDIT_ROW' && item.Is_Multi==='Y') {

                          @for (column of item.Line_data.slice(1, item.Line_data.length); track $index; let colIdx = $index) {
<td 
                              [ngStyle]="{'width': column.COLSPAN + '%'}">
                            
                            <!-- Label -->
                            @if (column.EDIT_TYPE==='label' && column.DATA_TYPE==='number') {
<div>
                              {{column.ATTRIB_VALUE}}
                              @if (column.HAS_ERROR==='Y') {
<span class="form-error-container">
                                {{column.ATTRIB_VALUE_ERROR}}
                              </span>
}
                            </div>
}
                            
                            <!-- Dropdown -->
                            @if (column.EDIT_TYPE === 'dropdown' && column.DATA_TYPE==='string') {
<div 
                                 style="margin-top: 12px !important;">
                              <select style="width: 200px;" 
                                      class="form-control" 
                                      [(ngModel)]="column.ATTRIB_VALUE"
                                      [name]="'dropdown_' + mainIndex + '_' + parentIndex + '_' + colIdx"
                                      (change)="valuechanged(parentIndex, column.TRANS_OCCURRENCE, column.LINE_NO, colIdx)">
                                <option value="">Select</option>
                                @for (option of formLOV; track $index) {
<option [value]="option.CODE_NAME">
                                  {{option.CODE_DESC}}
                                </option>
}
                              </select>
                              @if (column.HAS_ERROR==='Y') {
<span class="form-error-container">
                                {{column.ATTRIB_VALUE_ERROR}}
                              </span>
}
                            </div>
}
                            
                            <!-- Radio - Schedule -->
                            @if (column.EDIT_TYPE==='radio' && column.DATA_TYPE==='string' && column.ATTRIB_DESCRIPTION==='Schedule') {
<div 
                                 style="margin-top: 12px !important;">
                              <label class="radio-inline">
                                <input type="radio" 
                                       [name]="'schedule_' + mainIndex + '_' + parentIndex"
                                       value="D"
                                       [checked]="column.ATTRIB_VALUE === 'D'"
                                       (change)="column.ATTRIB_VALUE = 'D'; valuechanged(parentIndex, column.TRANS_OCCURRENCE, column.LINE_NO, colIdx)">
                                Schedule D
                              </label>
                              <label class="radio-inline">
                                <input type="radio" 
                                       [name]="'schedule_' + mainIndex + '_' + parentIndex"
                                       value="4797"
                                       [checked]="column.ATTRIB_VALUE === '4797'"
                                       (change)="column.ATTRIB_VALUE = '4797'; valuechanged(parentIndex, column.TRANS_OCCURRENCE, column.LINE_NO, colIdx)">
                                Form 4797
                              </label>
                            </div>
}
                            
                            <!-- Radio - Long/Short Term -->
                            @if (column.EDIT_TYPE==='radio' && column.DATA_TYPE==='string' && column.ATTRIB_DESCRIPTION==='Long / Short Term') {
<div 
                                 style="margin-top: 12px !important;">
                              <label class="radio-inline">
                                <input type="radio" 
                                       [name]="'longshort_' + mainIndex + '_' + parentIndex"
                                       value="Short Term"
                                       [checked]="column.ATTRIB_VALUE === 'Short Term'"
                                       (change)="column.ATTRIB_VALUE = 'Short Term'; valuechanged(parentIndex, column.TRANS_OCCURRENCE, column.LINE_NO, colIdx)">
                                Short Term
                              </label>
                              <label class="radio-inline">
                                <input type="radio" 
                                       [name]="'longshort_' + mainIndex + '_' + parentIndex"
                                       value="Long Term"
                                       [checked]="column.ATTRIB_VALUE === 'Long Term'"
                                       (change)="column.ATTRIB_VALUE = 'Long Term'; valuechanged(parentIndex, column.TRANS_OCCURRENCE, column.LINE_NO, colIdx)">
                                Long Term
                              </label>
                              @if (column.HAS_ERROR==='Y') {
<span class="form-error-container">
                                {{column.ATTRIB_VALUE_ERROR}}
                              </span>
}
                            </div>
}
                            
                            <!-- Radio - Yes/No -->
                            @if (column.EDIT_TYPE==='radio' && column.DATA_TYPE==='string' && column.ATTRIB_DESCRIPTION !='Schedule' && column.ATTRIB_DESCRIPTION !='Long / Short Term') {
<div 
                                 style="margin-top: 12px !important;">
                              <label class="radio-inline">
                                <input type="radio" 
                                       [name]="'radio_' + mainIndex + '_' + parentIndex + '_' + colIdx"
                                       value="Yes"
                                       [checked]="column.ATTRIB_VALUE === 'Yes'"
                                       (change)="column.ATTRIB_VALUE = 'Yes'; valuechanged(parentIndex, column.TRANS_OCCURRENCE, column.LINE_NO, colIdx)">
                                Yes
                              </label>
                              <label class="radio-inline">
                                <input type="radio" 
                                       [name]="'radio_' + mainIndex + '_' + parentIndex + '_' + colIdx"
                                       value="No"
                                       [checked]="column.ATTRIB_VALUE === 'No'"
                                       (change)="column.ATTRIB_VALUE = 'No'; valuechanged(parentIndex, column.TRANS_OCCURRENCE, column.LINE_NO, colIdx)">
                                No
                              </label>
                              @if (column.HAS_ERROR==='Y') {
<span class="form-error-container">
                                {{column.ATTRIB_VALUE_ERROR}}
                              </span>
}
                            </div>
}
                            
                            <!-- Text -->
                            @if (column.EDIT_TYPE==='text' && column.DATA_TYPE==='string') {
<div>
                              <textarea class="form-control input-sm numText"
                                        [(ngModel)]="column.ATTRIB_VALUE"
                                        [name]="'text_' + mainIndex + '_' + parentIndex + '_' + colIdx"
                                        placeholder="Description"
                                        (ngModelChange)="valuechanged(parentIndex, column.TRANS_OCCURRENCE, column.LINE_NO, colIdx)">
                              </textarea>
                              @if (column.HAS_ERROR==='Y') {
<span class="form-error-container">
                                {{column.ATTRIB_VALUE_ERROR}}
                              </span>
}
                            </div>
}
                            
                            <!-- Currency -->
                            @if (column.EDIT_TYPE==='currency' && column.DATA_TYPE==='number') {
<div>
                              <input type="text"
                                     class="form-control input-md numText"
                                     [(ngModel)]="column.ATTRIB_VALUE"
                                     [name]="'currency_' + mainIndex + '_' + parentIndex + '_' + colIdx"
                                     onlyIntegersWithLength
                                     (blur)="updateAmount(parentIndex, column.TRANS_OCCURRENCE, column.LINE_NO)"
                                     (ngModelChange)="valuechanged(parentIndex, column.TRANS_OCCURRENCE, column.LINE_NO, colIdx)">
                              @if (column.HAS_ERROR==='Y') {
<span class="form-error-container">
                                {{column.ATTRIB_VALUE_ERROR}}
                              </span>
}
                            </div>
}
                            
                            <!-- Date Picker -->
                            @if (column.EDIT_TYPE == 'custom_date_various' && column.DATA_TYPE==='dateVarious') {
<div class="input-group formDatePicker" 
                                >
                              <input type="date"
                                     class="form-control"
                                     [ngModel]="convertToDateInputFormat(column.ATTRIB_VALUE)"
                                     (ngModelChange)="onDateChange($event, column)"
                                     [name]="'date_' + mainIndex + '_' + parentIndex + '_' + colIdx"
                                     [disabled]="column.conditionalField">
                              @if (column.HAS_ERROR==='Y') {
<span class="form-error-container">
                                {{column.ATTRIB_VALUE_ERROR}}
                              </span>
}
                            </div>
}
                            
                          </td>
}
                        
}
                        
                      </tr>
}
                    </table>
                  </td>
                </tr>
}
              
}
            </table>
          </div>
}

          <!-- Spacer -->
          <div>
            <table>
              <tbody>
                <tr>
                  <td>&nbsp;</td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Transaction Attributes Table -->
          @if (showAttributes) {
<div>
            <table class="table table-bordered form-inline customTable custom-table">
              <thead>
                <tr>
                  <th id="CRD_LINENO_CRUD_1" class="sticky-col">{{tableHeader[0]?.LINE_NO}}</th>
                  <th id="CRD_DESC_CRUD_2" class="sticky-col">{{tableHeader[0]?.DESCRIPTION}}</th>
                  <th id="CRD_HEADER_CRUD_3" class="sticky-col">{{tableHeader[0]?.ATTRIB_DESCRIPTION}}</th>
                </tr>
              </thead>
              <tbody>
                @for (row of filteredOuterList; track $index; let idx = $index) {
<tr class="formDataBlock" 
                   >
                  
                  <!-- Line Number Column -->
                  @if (row.ROW_TYPE != 'PH') {
<td>{{row.LINE_NO}}</td>
}
                  @if (row.ROW_TYPE == 'PH') {
<td [class.color-red]="row.ROW_TYPE == 'PH'">
                    <b>{{row.LINE_NO}}</b>
                  </td>
}
                  
                  <!-- Description Column -->
                  @if (row.ROW_TYPE == 'PH') {
<td [class.color-red]="row.ROW_TYPE == 'PH'">
                    <b>{{row.DESCRIPTION}}</b>
                  </td>
}
                  @if (row.ROW_TYPE != 'PH' && row.LINE_NO != '29(a)') {
<td>
                    <span>{{row.DESCRIPTION}}</span>
                  </td>
}
                  <!-- For line 29(a) Date -->
                  @if (row.ROW_TYPE != 'PH' && row.LINE_NO == '29(a)') {
<td>
                    <span>{{row.DESCRIPTION}}</span>
                    <div class="input-group formDatePicker">
                      <input type="date"
                             class="form-control"
                             [ngModel]="convertToDateInputFormat(row.line29DateVal)"
                             (ngModelChange)="onLine29aDateChange($event, row, idx)"
                             [name]="'line29date_' + idx"
                             [disabled]="row.conditionalField">
                    </div>
                  </td>
}

                  <!-- Value Column - Non-Radio, Non-PH -->
                  @if (row.EDIT_TYPE != 'radio' && row.ROW_TYPE != 'PH') {
<td align="center" 
                      
                      style="width: 17%;">
                    
                    <!-- Not Editable - Display Only -->
                    @if (row.IS_EDITABLE_CELL == 'N') {
<div style="text-align: right; padding-right: 10px" 
                         
                         [class.color-red]="row.ATTRIB_VALUE < 0">
                      <span id="CRDNOTEDITABLE_{{activeTab}}_CRUD_{{idx + 1}}">
                        {{row.ATTRIB_VALUE | number}}
                      </span>
                    </div>
}
                    
                    <!-- Editable - Number or String Input -->
                    @if (row.IS_EDITABLE_CELL == 'Y' && row.EDIT_TYPE != 'checkbox' && row.EDIT_TYPE != 'custom_date_various' && row.EDIT_TYPE != 'dropdown') {
<div style="text-align: right; padding-right: 10px" 
                        >
                      
                      <!-- Number Input -->
                      @if (row.DATA_TYPE == 'number') {
<div>
                        <input id="CRDNO_{{activeTab}}_CRUD_{{idx + 1}}" 
                               class="form-control input-md numText"
                               style="text-align: right" 
                               type="text"
                               [(ngModel)]="row.ATTRIB_VALUE"
                               [name]="'input_num_' + idx"
                               onlyIntegersWithLength
                               (blur)="updateAmount(idx, row.TRANS_OCCURRENCE, row.LINE_NO)" 
                               (ngModelChange)="valuechanged(idx, row.TRANS_OCCURRENCE, row.LINE_NO, idx)">
                      </div>
}
                      
                      <!-- String Input -->
                      @if (row.DATA_TYPE == 'string') {
<div>
                        <input id="CRDSTRING_{{activeTab}}_CRUD_{{idx + 1}}" 
                               class="form-control input-md numText"
                               style="text-align: right" 
                               type="text"
                               [(ngModel)]="row.ATTRIB_VALUE"
                               [name]="'input_str_' + idx"
                               (ngModelChange)="valuechanged(idx, row.TRANS_OCCURRENCE, row.LINE_NO, idx)">
                      </div>
}
                    </div>
}
                    
                    <!-- Checkbox -->
                    @if (row.EDIT_TYPE == 'checkbox') {
<div>
                      <input id="CRDCHECKBOX_{{activeTab}}_CRUD_{{idx + 1}}" 
                             type="checkbox" 
                             [checked]="row.ATTRIB_VALUE === 'true'"
                             (change)="onCheckboxChange($event, row); valuechanged(idx, row.TRANS_OCCURRENCE, row.LINE_NO, idx)">
                      {{row.ATTRIB_DESCRIPTION}}
                    </div>
}
                    
                    <!-- Dropdown -->
                    @if (row.EDIT_TYPE == 'dropdown') {
<div>
                      <select id="CRDDROPDOWN_{{activeTab}}_CRUD_{{idx + 1}}" 
                              style="width: 200px" 
                              class="form-control" 
                              [(ngModel)]="row.ATTRIB_VALUE"
                              [name]="'dropdown_attr_' + idx">
                        <option value="">Select</option>
                        @for (option of formLOV; track $index) {
<option [value]="option.CODE_NAME">
                          {{option.CODE_DESC}}
                        </option>
}
                      </select>
                    </div>
}

                    <!-- Date Picker -->
                    @if (row.EDIT_TYPE == 'custom_date_various') {
<div>
                      <div class="input-group">
                        <input type="date" 
                               class="form-control" 
                               [ngModel]="convertToDateInputFormat(row.ATTRIB_VALUE)"
                               (ngModelChange)="onDateChange($event, row)"
                               [name]="'date_attr_' + idx">
                      </div>
                    </div>
}
                  </td>
}
                  
                  <!-- Radio Button Group Column -->
                  @if (row.EDIT_TYPE == 'radio') {
<td style="padding-left: 30px;">
                    @for (rowData of radioLines; track $index; let radioIdx = $index) {

                      @if (rowData.EDIT_TYPE == 'radio' && rowData.TRANS_OCCURRENCE === currentOccurrence && row.FORM_LINE_KEY === rowData.FORM_LINE_KEY) {
<div
                           style="display: inline !important; margin-right: 24px;">
                        <input type="checkbox" 
                               [checked]="rowData.ATTRIB_VALUE === 'true'"
                               (change)="onRadioCheckboxChange($event, rowData)">
                        {{rowData.ATTRIB_DESCRIPTION}}
                      </div>
}
                    
}
                  </td>
}
                </tr>
}
              </tbody>
            </table>
          </div>
}
        </div>
      </form>
}
  </div>
</div>

<!-- Footer -->
<div class="modal-footer" [hidden]="minimise">
  <button class="save-button" 
          type="button" 
          [disabled]="isSaveClicked" 
          (click)="save(currentOccurrence, 'save')">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save and Proceed
  </button>
  <button class="reset-button" 
          type="button" 
          (click)="reset()">Reset</button>
  <button class="cancel-button" 
          type="button" 
          (click)="cancel()">Cancel</button>
</div>

